/**
 * Cliente HTTP do curso (loja-api).
 */

const API_BASE_URL =
  (typeof window !== 'undefined' && window.__REACT_APP_LOJA_API_URL) ||
  process.env.REACT_APP_LOJA_API_URL ||
  'http://localhost:4001';

async function request(path, { method = 'GET', token } = {}) {
  const headers = {};
  if (token) headers.Authorization = `Bearer ${token}`;

  const response = await fetch(`${API_BASE_URL}${path}`, { method, headers });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const err = new Error(data?.error || `Erro HTTP ${response.status}`);
    err.status = response.status;
    err.data = data;
    throw err;
  }
  return data;
}

export const courseService = {
  getCourse: () => request('/api/course'),
  getAccess: (token) => request('/api/course/access', { token }),
  getLesson: (token, lessonId) => request(`/api/course/lesson/${lessonId}`, { token }),
  toggleLessonComplete: (token, lessonId) =>
    request(`/api/course/lesson/${lessonId}/complete`, { method: 'POST', token }),
};
